import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { NavLink as RouterNavLink, useLocation } from 'react-router-dom';

type SearchLocation = { search?: string } | string;

const getSearch = (location: SearchLocation): string => {
  if (typeof location === 'string') {
    return new URL(location, window.location.origin).search || '';
  }

  return location.search || '';
};

const isSearchEqual = (
  loc1: SearchLocation = '',
  loc2: SearchLocation = '',
): boolean => {
  const search1 = getSearch(loc1);
  const search2 = getSearch(loc2);

  if (search1 === search2) return true;

  const toSortedArray = (search: string) =>
    search.substring(1).split('&').toSorted();

  return _.isEqual(toSortedArray(search1), toSortedArray(search2));
};

interface NavLinkProps
  extends Omit<React.ComponentProps<typeof RouterNavLink>, 'end'> {
  className?: string;
  activeClassName?: string;
  onlyActiveOnIndex?: boolean;
  onlyActiveOnSearchMatch?: boolean;
}

const NavLink = React.forwardRef<HTMLAnchorElement, NavLinkProps>(
  (
    {
      className,
      onlyActiveOnSearchMatch,
      onlyActiveOnIndex,
      activeClassName,
      ...props
    },
    ref,
  ) => {
    const location = useLocation();
    return (
      <RouterNavLink
        ref={ref}
        className={(navState) => {
          const isActive =
            navState.isActive &&
            (!onlyActiveOnSearchMatch || isSearchEqual(location, props.to));

          return (
            classNames(
              className,
              activeClassName && { [activeClassName]: isActive },
            ) || undefined
          );
        }}
        end={onlyActiveOnIndex}
        {...props}
      />
    );
  },
);

export default NavLink;
